import { render, staticRenderFns } from "./winDeal.vue?vue&type=template&id=2c1efb36"
import script from "./winDeal.vue?vue&type=script&lang=js"
export * from "./winDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports